/**
 * Keep the FrontRow Clinicians' Choice modal on the viewport.
 * FrontRow appends #frontrow-portal to body, but older embeds and theme
 * overflow/transform (gallery, featured product) can leave the iframe
 * inside the main image — so on mobile the popup opens off-screen.
 */
(function (window, document) {
  'use strict';

  if (window.__aaFrontrowModalInit) return;
  window.__aaFrontrowModalInit = true;

  var MODAL_FRAMES = 'iframe.iframe.frontrow, iframe[class*="iframe-modal-frontrow"], iframe.iframe-provider-profile-modal';

  function pinToViewport() {
    var body = document.body;
    if (!body) return;

    var portal = document.getElementById('frontrow-portal');
    if (portal && portal.parentNode !== body) {
      body.appendChild(portal);
    }

    document.querySelectorAll(MODAL_FRAMES).forEach(function (frame) {
      if (portal) {
        if (frame.parentNode !== portal) portal.appendChild(frame);
        return;
      }
      if (frame.parentNode !== body) body.appendChild(frame);
    });
  }

  function callOpenFrModal(utm) {
    pinToViewport();
    if (typeof window.openFrModal !== 'function') return false;
    window.openFrModal('quant', utm || 'pdp-proof');
    pinToViewport();
    return true;
  }

  function openWhenReady(utm) {
    if (callOpenFrModal(utm)) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (callOpenFrModal(utm) || tries > 40) window.clearInterval(timer);
    }, 150);
  }

  function wrapOpener() {
    var original = window.openFrModal;
    if (typeof original !== 'function' || original.__aaPinned) return;
    var wrapped = function () {
      pinToViewport();
      var result = original.apply(this, arguments);
      pinToViewport();
      return result;
    };
    wrapped.__aaPinned = true;
    window.openFrModal = wrapped;
  }

  window.aaOpenFrModal = openWhenReady;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-aa-open-fr-modal]');
    if (!trigger) return;
    event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    openWhenReady(trigger.getAttribute('data-aa-open-fr-modal') || 'pdp-proof');
  });

  wrapOpener();
  var wrapTries = 0;
  var wrapTimer = window.setInterval(function () {
    wrapOpener();
    if ((typeof window.openFrModal === 'function' && window.openFrModal.__aaPinned) || ++wrapTries > 40) {
      window.clearInterval(wrapTimer);
    }
  }, 150);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinToViewport);
  } else {
    pinToViewport();
  }

  if (window.MutationObserver) {
    new MutationObserver(function () {
      pinToViewport();
      wrapOpener();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})(window, document);
